import { useToaster, Message } from 'rsuite';
import Api from "../util/Api";

const messageDefaults = {
    placement: 'topEnd',
    show: true
}
const errorMessageDefaults = {
    type: 'warning',
    title: 'Warning',
    message: 'Request failed',
}
const successMessageDefaults = {
    type: 'success',
    title: 'Success',
    message: 'Request successfully resolved',
}

function useRequestHandler(data) {
    const {
        auth = null,
        apiName = null,
        apiArguments = [],
        errorMessageData = {
            type: 'warning',
            title: 'Warning',
            message: 'Request failed',
            placement: 'topEnd',
            show: true,
            duration: 2000
        },
        successMessageData = {
            type: 'success',
            title: 'Success',
            message: 'Request successfully resolved',
            placement: 'topEnd',
            show: true,
            duration: 2000
        }
    } = data;

    const errorMessage = {
        ...messageDefaults,
        ...errorMessageDefaults,
        ...errorMessageData
    }

    const successMessage = {
        ...messageDefaults,
        ...successMessageDefaults,
        ...successMessageData
    }


    const toaster = useToaster();

    return async (
        onSuccess = null,
        onError = null,
        extraArguments = []
    ) => {

        try {
            const data = await Api.withAuth(auth)[apiName](...[...apiArguments, ...extraArguments]);
            if(typeof onSuccess === 'function') onSuccess(data);

            successMessage.show &&
            toaster.push(
                <Message
                    type={successMessage.type}
                    duration={successMessage.duration}
                >
                    <h6>{successMessage.title}</h6>
                    <p className='m-0'>{successMessage.message}</p>
                </Message>,
                {placement: successMessage.placement}
            );

            return data;
        } catch (e) {
            if(typeof onError === 'function') onError(e);

            errorMessage.show &&
            toaster.push(
                <Message
                    type={errorMessage.type}
                    duration={errorMessage.duration}
                >
                    <h6>{errorMessage.title}</h6>
                    <p className='m-0'>{errorMessage.message}</p>
                </Message>,
                {placement: errorMessage.placement}
            );

            return e;
        }
    }

}

export default useRequestHandler;